export default "__VITE_ASSET__Fb6q0yQl__"